module.exports = __webpack_public_path__ + "d2a55d331bdd1a7ea97a8a1fbb3c569c.woff";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/material-design-iconic-font/fonts/Material-Design-Iconic-Font.woff
// module id = 306
// module chunks = 1